import { ReactNode, createContext } from "react";
import useObservacaoContrato, { ObservacaoContratoType, CreateObservacaoContratoType, EditObservacaoContratoType} from "./hooks/useObservacaoContrato";

interface ObservacaoContratoContextProviderProps {
    children: ReactNode;
}

export interface ObservacaoContratoContextData {
    createObservacaoContrato: (createObservacaoContratoData: CreateObservacaoContratoType) => Promise<CreateObservacaoContratoType | null>;
    getObservacaoContratoPaged: (
        pageNumber: number,
        pageSize?: number,
        ContratoId?: number
    ) => Promise<ObservacaoContratoType[] | null>;
    updateObservacaoContrato: (editObservacaoContratoData: EditObservacaoContratoType) => Promise<EditObservacaoContratoType | null>;
    deleteObservacaoContrato: (observacaoContratoId: number) => Promise<ObservacaoContratoType | null>;
    setObservacaoContrato: any;
    observacaoContrato: ObservacaoContratoType;
    listObservacaoContrato: ObservacaoContratoType[];
    initialListObservacaoContrato: ObservacaoContratoType[];
    setListObservacaoContrato: (observacaoContrato: ObservacaoContratoType[]) => void;
    setObservacaoContratoPageCount: (count: number) => void;
    observacaoContratoPageCount: number;
}

const initialState: ObservacaoContratoContextData = {
    createObservacaoContrato: async () => null,
    getObservacaoContratoPaged: async () => null,
    updateObservacaoContrato: async () => null,
    deleteObservacaoContrato: async () => null,
    setObservacaoContrato: () => { },
    observacaoContrato: {
        id: 0,
        observation: "",
        date: "",
        contratoId: null,
    },
    listObservacaoContrato: [],
    initialListObservacaoContrato: [],
    setListObservacaoContrato: () => { },
    setObservacaoContratoPageCount: () => { },
    observacaoContratoPageCount: 0,
};

export const ObservacaoContratoContext =
    createContext<ObservacaoContratoContextData>(initialState);

export default function ObservacaoContratoContextProvider({
    children,
}: ObservacaoContratoContextProviderProps) {
    const {
        createObservacaoContrato,
        getObservacaoContratoPaged,
        updateObservacaoContrato,
        deleteObservacaoContrato,
        observacaoContrato,
        listObservacaoContrato,
        initialListObservacaoContrato,
        setListObservacaoContrato,
        setObservacaoContratoPageCount,
        observacaoContratoPageCount,
    } = useObservacaoContrato();

    return (
        <ObservacaoContratoContext.Provider
            value={{
                createObservacaoContrato,
                getObservacaoContratoPaged,
                updateObservacaoContrato,
                deleteObservacaoContrato,
                setObservacaoContrato: () => { },
                observacaoContrato,
                listObservacaoContrato,
                initialListObservacaoContrato,
                setListObservacaoContrato,
                setObservacaoContratoPageCount,
                observacaoContratoPageCount,
            }}
        >
            {children}
        </  ObservacaoContratoContext.Provider>
    );
}
